import {useMemo} from 'react';
import useSWR, {SWRResponse} from 'swr';
import {IGoogleCustomers} from 'src/types/google/GoogleCustomer';

export const useGoogleCustomers = (authToken: string | null): SWRResponse<IGoogleCustomers> => {
  const URL = useMemo(() => `${process.env.REACT_APP_BACKEND_URL}/google/customers?auth=${authToken}`, [authToken]);
  return useSWR(authToken ? URL : null);
};
